<template>
    <div class="organization-settings">
        <b-tabs content-class="organization-tab-content" class="organization-settings-tab apprentice-tab">
            <b-tab :title="$t('organization.general')">
                <design-2021-organization-settings-general-component
                    :organization-in="organizationIn"
                ></design-2021-organization-settings-general-component>
            </b-tab>

            <b-tab :title="$t('organization.users')" active>
                <design-2021-organization-settings-users-component
                    :organization-in="organizationIn"
                ></design-2021-organization-settings-users-component>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: "design-2021-organization-settings-index-component",
    props: [
        'organizationIn',
    ]
}
</script>

<style scoped>

</style>
